import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-carvet-up-down-descending",
  "use": "arrow-carvet-up-down-descending-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-carvet-up-down-descending\"><path d=\"M11.855 10.854A.5.5 0 0011.5 10h-6a.5.5 0 00-.354.854l3 3a.5.5 0 00.708 0l3-3z\" /><path d=\"M5.147 6.146A.5.5 0 005.501 7h6a.5.5 0 00.354-.854l-3-3a.5.5 0 00-.708 0l-3 3z\" fill-opacity=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol